import { render, staticRenderFns } from "./ycassa.vue?vue&type=template&id=2862e0f6&"
import script from "./ycassa.vue?vue&type=script&lang=js&"
export * from "./ycassa.vue?vue&type=script&lang=js&"
import style0 from "./ycassa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
